import http, { createApi } from '@core/fetch'

export default {
  menuIds: createApi('/p/wedding/Admin/APIMerchant/MenuIds', { expect: [] }),
  // 产品权限 http://autotest.hunliji.com/#/home/project/api/edit?projectId=-701335349&apiId=216026&moduleid=5199
  // 权益code http://api.hljnbw.cn/project/735/interface/api/97567
  productAuth: body => {
    return http('/hms/merchantPolicy/appApi/merchant/policy/list', {
      body
    })
  },
  isOpenHcy: () => {
    return http('/hms/hljMerchantCenter/appApi/corporation/hcyStatus')
  }
}
